import { gql } from '@apollo/client';
export const UPLOAD_MUTATION = gql`
  mutation UploadMutation($file: Upload!) {
    upload(file: $file) {
      id
      url
      previewUrl
      formats
    }
  }
`;
